<template>
 <router-view></router-view>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { useLockScreen } from '@/composables/useLockScreen';

export default {
  name: 'App',
  setup() {
    const { startIdleTimer, stopIdleTimer, clearLockState } = useLockScreen();
    return { startIdleTimer, stopIdleTimer, clearLockState };
  },
  computed: {
    ...mapGetters('system', ['logo', 'favicon']),
    tabIcon() {
      return this.favicon || this.logo;
    }
  },
  methods: {
    ...mapActions('system', ['fetchSettings']),
    updateFavicon(url) {
      const link = document.querySelector("link[rel='icon']") || document.createElement('link');
      const resolved = url || require('@/assets/images/logo/aai_logo_new.png');
      const ext = (resolved.split('?')[0].split('.').pop() || '').toLowerCase();
      const mime = {
        ico: 'image/x-icon',
        svg: 'image/svg+xml',
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        gif: 'image/gif',
        webp: 'image/webp',
      }[ext] || 'image/png';
      link.rel = 'icon';
      link.type = mime;
      link.href = resolved;
      document.head.appendChild(link);
    }
  },
  mounted() {
    this.fetchSettings();

    // Start idle timer if user is authenticated
    const token = localStorage.getItem('auth_token');
    if (token) {
      this.startIdleTimer();
    }
  },
  beforeUnmount() {
    this.stopIdleTimer();
  },
  watch: {
    tabIcon(url) {
      this.updateFavicon(url);
    },
    // Watch for route changes to manage idle timer
    '$route'(to) {
      const token = localStorage.getItem('auth_token');
      if (to.name === 'login') {
        // Clear lock state on login page
        this.clearLockState();
      } else if (token && to.name !== 'lock-screen') {
        // Restart idle timer on authenticated pages
        this.startIdleTimer();
      }
    }
  },
  components: {
  }
}
</script>
